import 'mutationobserver-shim';
import Vue from 'vue';
import _ from 'lodash';

// vue-router, vuex config (don't change the order)
import router from './router';
import store from './store';

const storeConfig = {
   store,
};

// plugin configuration
import './plugins/bootstrap-vue';
import {Plugin as AxiosPlugin} from './plugins/axios';
Vue.use(AxiosPlugin, storeConfig);

import Constants from './plugins/constants';
Vue.use(Constants);
import KeycloakPlugin from './plugins/keycloak';

// Websocket plugin
import {Plugin as WebsocketPlugin} from './plugins/websocket';
Vue.use(WebsocketPlugin, storeConfig);

// App entry point
import App from './App.vue';

// register global components
import './views';
import './components';

// register global mixins and directives
import './mixins';
import './directives';

// vue-advenced-cropper styles
// import 'vue-advanced-cropper/dist/style.css';

// site-wide styles
import './assets/css/main.scss';

// other packages
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

// Define the behavior when merging validations from a mixin
// with validations in a component
function mergeValidations(a, b) {
   if (typeof a === 'function' || typeof b === 'function') {
      return function () {
         const aObj = typeof a === 'function' ? a.call(this) : a;
         const bObj = typeof b === 'function' ? b.call(this) : b;
         return _.merge(aObj, bObj);
      };
   }
   return _.merge(a, b);
}
Vue.config.optionMergeStrategies.validations =
   Vue.config.optionMergeStrategies.validations || mergeValidations;

import VCalendar from 'v-calendar';
Vue.use(VCalendar);

Vue.config.productionTip = false;

// Reduce noisy duplicate warnings while keeping visibility of important signals.
// This is intentionally narrow: it targets a known repeated vue-router deprecation
// warning emitted by third-party wrappers around <router-link>.
const ROUTER_TAG_DEPRECATION = "<router-link>'s tag prop is deprecated";
const warningCounts = new Map();
Vue.config.warnHandler = (msg, _vm, trace = '') => {
   const count = (warningCounts.get(msg) || 0) + 1;
   warningCounts.set(msg, count);

   if (!msg.includes(ROUTER_TAG_DEPRECATION)) {
      console.warn(`[Vue warn]: ${msg}${trace}`);
      return;
   }

   if (count === 1) {
      console.warn(`[Vue warn]: ${msg}${trace}`);
      console.warn('[Vue warn]: Repeated router-link tag deprecation warnings will be summarized.');
      return;
   }

   if (count % 25 === 0) {
      console.warn(
         `[Vue warn]: ${ROUTER_TAG_DEPRECATION} repeated ${count} times in this session.`
      );
   }
};

const kcConfig = {
   url: '/auth',
   realm: 'TaxCreditPortal',
   clientId: 'app',
};

const kcInit = {
   checkLoginIframe: false,
};

// Create keycloak instance and make it available on our Vue instance
Vue.use(KeycloakPlugin, kcConfig);

Vue.$keycloak.init(kcInit).then(() => {
   // We also need to fetch the user session before we can do anything else.
   store
      .dispatch('fetchUserSession')
      .then(() => {
         // Start the app
         window.$app = new Vue({
            router,
            store,
            render: (h) => h(App),
         }).$mount('#app');
      })
      .catch((err) => {
         console.log('Failed to retrieve session:', err);
      });

   // load app version
   store.dispatch('fetchVersion');

   // Update token when window gains focus
   window.onfocus = () => {
      if (Vue.$keycloak.authenticated) {
         Vue.updateToken();
      }
   };
});
